module.exports = __webpack_public_path__ + "img/FRE.ee4c14ca.png";